import {Component}    from '@angular/core';
import {MapViewStore} from '../../stores/layout/mapview.store';


///
/// As per ticket APV49-1463 User profile edit is temporary disabled
///

/*export enum SettingsTabs {
  UserProfile = 0,
  UserSettings = 1,
}*/

@Component({
  selector: 'ap-userprofile-usersettings',
  templateUrl: './ap-userprofile-usersettings.component.html'
})
export class ApUserProfileUserSettingsComponent {
  /*public apPermissionData: IApPermissionData;
  public ApPermissions = ApPermissions;

  @ViewChild(ApUserProfileEditComponent, {static: false})
  public userProfileComponent: ApUserProfileEditComponent;

  @ViewChild(ApUserSettingsComponent, {static: false})
  public userSettingsComponent: ApUserSettingsComponent;

  public selectedTab: SettingsTabs = SettingsTabs.UserProfile;*/

  constructor(/*private farmUsersStore: FarmUsersStore,
              private permissionsStore: AccessPermissionsStore,*/
              private mapViewStore: MapViewStore) {
    this.mapViewStore.hideMapView();
  }

  /*selectTab(e): void {
    switch (this.selectedTab) {
      case SettingsTabs.UserProfile:
        break;
      case SettingsTabs.UserSettings:
        break;
    }
    this.selectedTab = e.index;
  }*/
}
